export default "__VITE_ASSET__CcLiARtM__"